<app-confirmed-membership *transloco="let t">
  <app-main-header header>{{ t('new-business-acceptance') }}</app-main-header>
  <app-header isBig title>{{ t('congratulations-organization-membership', { organization: newBusiness.businessName })}}</app-header>
  <app-rounded-image image [src]="newBusiness.imgSource"></app-rounded-image>
  <div buttonSection>
    <app-primary-button id="lnr-confirmed-representative-membership" [routerLink]="'/'+RoutesKeys.HOME">
      {{ t('go-home') }}
    </app-primary-button>
  </div>
</app-confirmed-membership>
